import { render, staticRenderFns } from "./CountrySwitcher.vue?vue&type=template&id=82ce383e&scoped=true"
import script from "./CountrySwitcher.vue?vue&type=script&lang=js"
export * from "./CountrySwitcher.vue?vue&type=script&lang=js"
import style0 from "./CountrySwitcher.vue?vue&type=style&index=0&id=82ce383e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ce383e",
  null
  
)

export default component.exports